import { NavLink } from "react-router-dom";
import {  useEffect } from "react";
//import { FaSignOutAlt } from "react-icons/fa";

export default function Sidebar({ isOpen, setIsOpen, setActiveMenu }) {

  //const navigate = useNavigate();
  const role = sessionStorage.getItem("role");
  const userData = JSON.parse(sessionStorage.getItem("userData")) || "{}";

  //const [attendanceOpen, setAttendanceOpen] = useState(false);

  const handleLogout = () => {
    sessionStorage.clear();
    window.location.href = "/login";
  };

  // Disable scroll when sidebar open (mobile UX improvement)
  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "auto";
  }, [isOpen]);

  return (
    <>
      {/* Overlay for mobile */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-40 md:hidden z-40"
          onClick={() => setIsOpen(false)}
        ></div>
      )}

      {/* Sidebar */}
      <aside
        className={`
          fixed md:static
          top-0 left-0
          h-full w-32
          text-white p-5
          transform
          ${isOpen ? "translate-x-0" : "-translate-x-full"}
          md:translate-x-0
          transition-transform duration-300
          z-50
        `}
        style={{ backgroundColor: "#0C59A4" }}
      >
        <ul className="space-y-4 mt-10 md:mt-0">

          {/* Dashboard */}
          <li>
            <NavLink
              to="/dashboard"
              end
              onClick={() => {
                setIsOpen(false);
                setActiveMenu(null);
              }}
              className={({ isActive }) =>
                `block p-2 rounded ${
                  isActive ? "bg-blue-700 text-white" : "hover:bg-blue-700"
                }`
              }
            >
              Home
            </NavLink>
          </li>

          {/* Attendance */}
          <li>
            <NavLink
              to="markattendance"
              onClick={() => {
                setIsOpen(false);
                setActiveMenu(null);
              }}
              className={({ isActive }) =>
                `block p-2 rounded ${
                  isActive ? "bg-blue-700" : "hover:bg-blue-700"
                }`
              }
            >
              Attendance
            </NavLink>
          </li>

          {/* My Time */}
          <li>
            <NavLink
              to="myTime"
              state={{ staffData: userData }}
              onClick={() => {
                setIsOpen(false);
                setActiveMenu(null);
              }}
              className={({ isActive }) =>
                `block p-2 rounded ${
                  isActive ? "bg-blue-700" : "hover:bg-blue-700"
                }`
              }
            >
              My Time
            </NavLink>
          </li>

          {/* Admin Only */}
          {role === "ADMIN" && (
            <>
              {/* Students */}
              <li>
                <NavLink
                  to="students"
                  onClick={() => {
                    setIsOpen(false);
                    setActiveMenu(null);
                  }}
                  className={({ isActive }) =>
                    `block p-2 rounded ${
                      isActive ? "bg-blue-700" : "hover:bg-blue-700"
                    }`
                  }
                >
                  Students
                </NavLink>
              </li>

              {/* Staff */}
              <li>
                <NavLink
                  to="staff"
                  onClick={() => {
                    setIsOpen(false);
                    setActiveMenu(null);
                  }}
                  className={({ isActive }) =>
                    `block p-2 rounded ${
                      isActive ? "bg-blue-700" : "hover:bg-blue-700"
                    }`
                  }
                >
                  Staff
                </NavLink>
              </li>

              {/* Users */}
              {/* <li>
                <NavLink
                  to="users"
                  onClick={() => {
                    setIsOpen(false);
                    setActiveMenu(null);
                  }}
                  className={({ isActive }) =>
                    `block p-2 rounded ${
                      isActive ? "bg-blue-700" : "hover:bg-blue-700"
                    }`
                  }
                >
                  Users
                </NavLink>
              </li> */}

              {/* Organisation */}
              <li>
                 <li>
                <NavLink
                  to="organisation"
                  onClick={() => {
                    setIsOpen(false);
                    setActiveMenu(null);
                  }}
                  className={({ isActive }) =>
                    `block p-2 rounded ${
                      isActive ? "bg-blue-700" : "hover:bg-blue-700"
                    }`
                  }
                >
                  Organise
                </NavLink>
              </li>
              </li>
            </>
          )}

          {/* Logout (mobile only) */}
          <li
            onClick={handleLogout}
            className="md:hidden flex items-center gap-3 p-3 cursor-pointer hover:bg-blue-900 rounded"
          >
           Logout
          </li>

        </ul>
      </aside>
    </>
  );
}